import React from "react";
import { LayersIcon } from "lucide-react";
import { WhatsAppIcon } from "./icons/BrandIcons";
import { links } from "../data/content";
const base = "inline-flex w-full items-center justify-center gap-2.5 rounded-[10px] px-6 py-4 text-[15px] font-bold whitespace-nowrap transition-[background-color,transform] duration-150 ease-out hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-base";
type CtaButtonsProps = {
  className?: string;
};
export function CtaButtons({
  className = "mx-auto"
}: CtaButtonsProps) {
  return <div className={`flex w-full max-w-[420px] flex-col items-stretch gap-3.5 ${className}`} data-id="element-11" data-mp="2cvomjyu0qobv">
      <a href={links.skool} target="_blank" rel="noopener noreferrer" className={`${base} bg-gold text-black hover:bg-gold-light focus-visible:ring-gold`} data-id="element-12" data-mp="2gwi84ljznr1l">
        <LayersIcon className="h-5 w-5" aria-hidden="true" data-id="element-13" data-mp="27tpkcsa0lxgi" />
        Unirme a Radar Digital — $27/mes
      </a>
      <a href={links.whatsapp} target="_blank" rel="noopener noreferrer" className={`${base} bg-wa text-white hover:bg-wa-dark focus-visible:ring-wa`} data-id="element-14" data-mp="1nm96nbim88jl">
        <WhatsAppIcon className="h-5 w-5" data-id="element-15" data-mp="1wnyts55gslbk" />
        Sumarme al grupo de WhatsApp gratis
      </a>
    </div>;
}